var CompanyType;
(function (CompanyType) {
    CompanyType["Proprietorship"] = "Proprietorship";
    CompanyType["SCorp"] = "SCorp";
    CompanyType["CCorp"] = "CCorp";
    CompanyType["LLC"] = "LLC";
    CompanyType["Partnership"] = "Partnership";
})(CompanyType || (CompanyType = {}));
export default CompanyType;
